import React, {useEffect,useRef } from 'react';

function ViewDemo() {

    const demoBoxRef = useRef(null);
    const videoRef = useRef(null);

    const _jqAutoCloseVideoPop = () => {
        if (videoRef.current) {
            videoRef.current.pause(); 
            videoRef.current.currentTime = 0;
        }
        if (demoBoxRef.current) {
            demoBoxRef.current.style.display = 'none';
        }
        window.location.reload();
    };

    const _jqListenVideoPop = () => {
        window.vGlobalNav = 1;
        setTimeout(() => {
            if (window.vGlobalNav === 1) {
                _jqAutoCloseVideoPop(); 
            }
        }, 3000);
    };

    const _jqNavToSignup = () => {
        console.log("Navigate to signup");
    };

    useEffect(() => {
        window._jqAutoCloseVideoPop = _jqAutoCloseVideoPop;
        window._jqListenVideoPop = _jqListenVideoPop;
        window._jqNavToSignup = _jqNavToSignup;
    }, []);
    return (
        <div ref={demoBoxRef} id="demo-box" className="video-container">
        <div id="btn_close_video" className="btn_close" title="Close" onClick={_jqAutoCloseVideoPop}></div>
        <video 
            id="sampleMovie"
            width="100%"
            controls="controls"
            preload="auto" 
            ref={videoRef}           
            onEnded={_jqListenVideoPop}
            onClick={_jqNavToSignup}>
            <source src="swf/assets/demo/demo.m4v" type="video/mp4" />
            <source src="swf/assets/demo/demo.ogv" type="video/ogg" />
        </video>
    </div>
    );
}

export default ViewDemo;
